<template>
  <div>
    <v-row dense>
      <v-col
        xl="12"
        lg="12"
        md="12"
        cols="12"
        v-if="
          !loadingCadastAprendizes &&
          configAprendizes &&
          configAprendizes.liberar_cadastramento
        "
      >
        <card-setores
          title="Programa Jovem Aprendiz"
          icon="mdi-school-outline"
          path="/jovem-aprendiz"
        >
          <lista-areas :areas="areasJA" />
        </card-setores>
      </v-col>
      <v-col
        cols="12"
        v-if="
          !loadingCadastAprendizes &&
          configAprendizes &&
          configAprendizes.aprendiz_industrial.lib_cadastro
        "
      >
        <card-setores
          title="Aprendiz Industrial"
          icon="mdi-school-outline"
          path="/acesso-aprendiz-industrial"
        >
          <informacoes-aprendiz-industrial />
        </card-setores>
      </v-col>
      <v-col cols="12">
        <card-setores
          title="Áreas disponíveis"
          icon="mdi-briefcase-outline"
          path="/acesso"
        >
          <v-row>
            <v-col xl="4" lg="4" md="4" cols="12">
              <v-card flat outlined rounded="lg" height="100%">
                <v-card-title class="font-weight-bold subtitle-1 pb-2"
                  >Áreas operacionais</v-card-title
                >
                <v-card-text>
                  <lista-areas :areas="areasOperacionais" />
                </v-card-text>
              </v-card>
            </v-col>
            <v-col xl="4" lg="4" md="4" cols="12">
              <v-card flat outlined rounded="lg" height="100%">
                <v-card-title class="font-weight-bold subtitle-1 pb-2"
                  >Áreas administrativas</v-card-title
                >
                <v-card-text>
                  <lista-areas :areas="areasAdm" />
                </v-card-text>
              </v-card>
            </v-col>
            <v-col xl="4" lg="4" md="4" cols="12">
              <v-card flat outlined rounded="lg" height="100%">
                <v-card-title class="font-weight-bold subtitle-1 pb-2"
                  >Áreas técnicas</v-card-title
                >
                <v-card-text>
                  <lista-areas :areas="areasTecnicas" />
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </card-setores>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import CardSetores from "./CardSetores.vue";
import InformacoesAprendizIndustrial from "./InformacoesAprendizIndustrial.vue";
import ListaAreas from "./ListaAreas.vue";
export default {
  components: { CardSetores, ListaAreas, InformacoesAprendizIndustrial },
  computed: mapState(["configAprendizes"]),
  data: () => ({
    loadingCadastAprendizes: true,
    areasAdm: [
      "Administrativo em geral",
      "Comercial",
      "Contabilidade",
      "Financeiro",
      "Recursos Humanos",
      "T.I (Tecnologia da Informação)",
    ],
    areasTecnicas: [
      "Assistência Técnica Agrícola",
      "Assistência Técnica Avícola",
      "Garantia da Qualidade",
      "Manutenção",
    ],
    areasOperacionais: [
      "Abatedouro/Frigorífico",
      "Armazém de Grãos",
      "Fábrica de Rações",
      "Supermercado",
      "Posto de Combustível",
      "Motorista",
    ],
    areasJA: ["Unidades de São João"],
    areasEstagio: ["Medicina Veterinária", "Agronomia"],
  }),
  methods: {
    ...mapActions(["getConfigAprendizes"]),
    isScreenSmall() {
      return this.$mq == "sm" || this.$mq == "md";
    },
  },
  async mounted() {
    this.loadingCadastAprendizes = true;
    await this.getConfigAprendizes();
    this.loadingCadastAprendizes = false;
  },
};
</script>

<style></style>
